// api/driverReferralAdminApi.js
import axios from "axios";

const BASE_URL = axios.create({
  baseURL: `${process.env.REACT_APP_SOCKET_URL}/api/driver-referral`,
});

const getHeaders = () => ({
  headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
});

// 📖 Get every driver with a pending (unpaid) referral incentive balance
// GET /api/driver-referral/admin/pending
export async function getAllPendingIncentives() {
  try {
    const res = await BASE_URL.get(`/admin/pending`, getHeaders());
    return res.data;
  } catch (err) {
    return { success: false, error: err.response?.data?.message || err.message };
  }
}

// ✅ Mark a driver's referral incentive as paid (after UPI/cash transfer)
// PATCH /api/driver-referral/admin/mark-paid/:driverId
// payload: { amount, paymentMode: "UPI"|"CASH"|"BANK_TRANSFER", transactionRef?, remarks? }
export async function markDriverIncentivePaid(driverId, payload) {
  try {
    const res = await BASE_URL.patch(`/admin/mark-paid/${driverId}`, payload, getHeaders());
    return res.data;
  } catch (err) {
    return { success: false, error: err.response?.data?.message || err.message };
  }
}

// 📜 Get full history of every payout ever made (all drivers) — the "what
// have we already sent" view, separate from getAllPendingIncentives which
// only shows what's still owed.
// GET /api/driver-referral/admin/payout-history
export async function getAllPayoutHistory() {
  try {
    const res = await BASE_URL.get(`/admin/payout-history`, getHeaders());
    return res.data;
  } catch (err) {
    return { success: false, error: err.response?.data?.message || err.message };
  }
}